/**
 * addToCart : call the custom event "cartUpdate"
 * @param  {eventTarget} eventTarget for prevent
 */

export function addToCart(form, eventTarget, atcButtonLocation, self) {
  eventTarget.preventDefault();
  const listProducts = [];
  const requestQuantity = form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : 1;
  form.querySelectorAll('.js-atc-list__item').forEach(item => {
    const defaultQuantity = item.querySelector('input[name="defaultQuantity"]') ? item.querySelector('input[name="defaultQuantity"]').value : 1;
    listProducts.push({
      quantity: defaultQuantity * requestQuantity,
      reflm: item.querySelector('input[name="reflm"]').value,
      offerId: item.querySelector('input[name="offerId"]').value,
      contextCode: item.querySelector('input[name="contextCode"]').value,
      atcButtonLocation
    });
  });
  self.cartUpdate({
    listProducts
  });
}